import { render, staticRenderFns } from "./CustomizeMetalK.vue?vue&type=template&id=4adcf2c7&scoped=true"
import script from "./CustomizeMetalK.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalK.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalK.vue?vue&type=style&index=0&id=4adcf2c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adcf2c7",
  null
  
)

export default component.exports